const ACCESS_DENIED_ROUTE = '/account/access-denied';
const LOGIN_ROUTE: string | null = null;

class BrowserRedirect {
  static HomePage = () => {
    if (typeof location !== 'undefined') {
      let url = '/';
      if (location) {
        const { search, hash } = location;
        url = search ? `${url}${search}` : url;
        url = hash ? `${url}${hash}` : url;
      }
      location.href = url;
    }
  };

  static SignInPage = async (redirectPath?: string) => {
    // Standard Contensis Login
    let url = LOGIN_ROUTE;
    if (url) {
      if (typeof redirectPath === 'string')
        url = `${url}?redirect_uri=${redirectPath}`;
      if (typeof location !== 'undefined' && redirectPath !== LOGIN_ROUTE)
        location.replace(url);
    }
  };

  static AccessDeniedPage = (originalPath?: string) => {
    let url = ACCESS_DENIED_ROUTE;
    if (originalPath === url) return;

    if (typeof originalPath === 'string')
      url = `${url}?original_uri=${originalPath}`;
    if (typeof location !== 'undefined') location.href = url;
  };

  static ToPath = (redirectPath?: string) => {
    if (typeof redirectPath === 'string') {
      if (typeof location !== 'undefined') location.href = redirectPath;
    } else BrowserRedirect.HomePage();
  };
}

export default BrowserRedirect;
